import { render, staticRenderFns } from "./reportCustomGroupManageList.vue?vue&type=template&id=cd24703e&scoped=true"
import script from "./reportCustomGroupManageList.vue?vue&type=script&lang=js"
export * from "./reportCustomGroupManageList.vue?vue&type=script&lang=js"
import style0 from "./reportCustomGroupManageList.vue?vue&type=style&index=0&id=cd24703e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd24703e",
  null
  
)

export default component.exports